<template>
  <div id="app">
    <div class="container">
      <a href="https://skugrid.com" target="_self">
        <div class="logo"></div>
      </a>
      <section class="section">
        <h1 class="title">Supplier Issues</h1>
        <AsanaStoresTable :data="tasks" />
        <div class="block">
          <a href="https://www.facebook.com/groups/skugrid/" target="_blank"
            ><b-icon icon="facebook"></b-icon
          ></a>
          <a href="https://twitter.com/skugrid" target="_blank"
            ><b-icon icon="twitter"></b-icon
          ></a>
          <a href="https://www.linkedin.com/company/skugrid" target="_blank"
            ><b-icon icon="linkedin"></b-icon
          ></a>
          <br />
          <a href="http://skugrid.freshdesk.com" target="_blank"
            >Create ticket</a
          >
        </div>
      </section>
    </div>
  </div>
</template>

<script>
const API_URL = "https://asanastorestatus.skuio.com/v1/tasks";

import AsanaStoresTable from "./components/AsanaStoresTable.vue";

export default {
  name: "App",
  data() {
    return {
      tasks: []
    };
  },
  async mounted() {
    let responseActiveTasks = await fetch(`${API_URL}/active?from=14`);
    if (responseActiveTasks.ok) {
      const { success, data } = await responseActiveTasks.json();
      if (success) {
        this.tasks.push(...data);
      }
    }

    let responseCompletedTasks = await fetch(`${API_URL}/completed?from=60`);
    if (responseCompletedTasks.ok) {
      const { success, data } = await responseCompletedTasks.json();
      if (success) {
        this.tasks.push(...data);
      }
    }
  },
  components: {
    AsanaStoresTable
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.logo {
  background: url("assets/logo.png") center center;
  width: 100px;
  height: 77px;
  border-radius: 5px;
  margin: 3rem 1.5rem;
}
</style>
